// extracted by mini-css-extract-plugin
export var active = "quickFilterButton-module--active--b0712";
export var badge = "quickFilterButton-module--badge--9d39e";
export var button = "quickFilterButton-module--button--23743";
export var danger = "quickFilterButton-module--danger--6cc9b";
export var smallText = "quickFilterButton-module--smallText--d406b";
export var warning = "quickFilterButton-module--warning--aff6d";
export var wide = "quickFilterButton-module--wide--064e5";